// src/services/api/nbaApi.js
import { rootApi } from './rootApi';

export const nbaApi = rootApi.injectEndpoints({
    endpoints: (build) => ({
        getNbaUpcomingGames: build.query({
            query: () => '/nba/upcoming',
            keepUnusedDataFor: 300, // 5 minutes cache
            providesTags: () => [{ type: 'UpcomingGames', id: 'NBA' }],
        }),
        getNbaGameScores: build.query({
            query: ({ homeTeamId, awayTeamId }) => 
                `/gateway/nba-gamescores?home=${homeTeamId}&away=${awayTeamId}`,
            keepUnusedDataFor: 300, // 5 minutes cache
            providesTags: (result, error, { homeTeamId, awayTeamId }) => [
                { type: 'GameScores', id: `NBA-${homeTeamId}-${awayTeamId}` }
            ],
        })
    }),
    overrideExisting: false,
});

export const { 
    useGetNbaUpcomingGamesQuery,
    useGetNbaGameScoresQuery,
} = nbaApi;